import Footer from '@/components/footer/footer'
import Header from '@/components/header/header'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { State, Getter, Action, Mutation } from 'vuex-class'

@Component({
  components: {
    Footer,
    Header
  }
})
export default class PerfilEdit extends Vue {
  photoPerfil = '';
  universityId: any = null;
  birth = {
    day: '',
    listDay: [],
    month: '',
    listMonth: [],
    year: '',
    listYear: []
  }
  form = {
    name: '',
    lastName: '',
    gender: '',
    career: '',
    semester: '',
    realationShipStatus: '',
    linkedin: '',
    facebook: '',
    instagram: '',
    google: ''
  }
  estadoCivilSelect = [
    { id: 'single', label: 'Solter@' },
    { id: 'married', label: 'Casad@' }
  ]
  isSendUpdate: boolean = false

  @State user: any
  @State userPhoto: any
  @Getter getUniversity: any
  @Getter getUser: any

  @Action action_putUser: any
  @Action action_getUser: any
  @Mutation PHOTO_USER: any
  @Mutation USER: any

  get suscribed() {
    return this.user.subscribed_to_marketing
      ? 'Actualmente estás suscrito a la mensajeria por SMS' : 'No estas suscrito a la mensajeria por SMS'
  }
  get universityLabel() {
    if (!this.universityId) {
      return { id: this.getUniversity.id, name: this.getUniversity.name }
    }
    return this.universityId
  }
  set universityLabel(value) {
    this.universityId = value
  }

  async cancelSuscription() {
    try {
      const data = {
        subscribed_to_marketing: false
      }
      await this.action_putUser(data)
      this.$swal({
        imageUrl: '/assets/images/ui/cohete.png',
        imageWidth: 100,
        title: 'Suscripción de SMS cancelada.',
        showConfirmButton: false,
        timer: 2000
      })
    } catch (error) {
      const status = error && error.response && error.response.status
      if (status >= 500) {
        this.$swal({
          title: 'Error al cancelar suscripción de SMS.',
          text: `Problemas con el servidor. Error ${status}`
        })
//        let message = 'Ayuda! \nMe está saliendo un error con el servidor.';
//        (window as any).Intercom('showNewMessage', message)
      } else {
        this.$swal({
          title: 'Error al cancelar suscripción de SMS.',
          text: error.response.data.message
        })
      }
    }
  }

  sendEdit() {
    this.isSendUpdate = true
    let data = {
      first_name: this.form.name,
      last_name: this.form.lastName,
      profile_picture: this.photoPerfil,
      gender: this.form.gender,
      major: this.form.career,
      date_of_birth: `${this.birth.year}-${this.birth.month}-${this.birth.day}`,
      semester: this.form.semester,
      relationship_status: (this.form as any).realationShipStatus.id,
      linkedin_url: this.form.linkedin,
      facebook_url: this.form.facebook,
      instagram_url: this.form.instagram,
      google_url: this.form.google
    }
    this.sendUser(data)
  }

  async sendUser(data: any, action: any = '') {
    try {
      const res = await this.action_putUser(data)
      this.isSendUpdate = false
      this.$swal({
        imageUrl: '/assets/images/ui/cohete.png',
        imageWidth: 100,
        title: 'Cambios Aplicados!',
        showConfirmButton: false,
        timer: 2000
      })
      if (action === 'push') {
        this.$router.push({ name: 'restaurant', params: { uni: res.data.university.name } })
      }
    } catch (error) {
      this.isSendUpdate = false
      const status = error && error.response && error.response.status
      if (status >= 500) {
        this.$swal({
          title: 'Error al editar perfil.',
          text: `Problemas con el servidor. Error ${status}`
        })
//        let message = 'Ayuda! \nMe está saliendo un error con el servidor.';
//        (window as any).Intercom('showNewMessage', message)
      } else {
        this.$swal({
          title: 'Error al editar perfil.',
          text: error.response.data.message
        })
      }
    }
  }

  fillForm() {
    if (this.getUser.date_of_birth) {
      let birth = this.getUser.date_of_birth.split('-')
      this.birth.day = birth[2]
      this.birth.month = birth[1]
      this.birth.year = birth[0]
    }
    let realationShipStatus
    switch (this.getUser.relationship_status) {
      case 'single':
        realationShipStatus = {
          id: 'single',
          label: 'Solter@'
        }
        break
      case 'married':
        realationShipStatus = {
          id: 'married',
          label: 'Casad@'
        }
        break
      default:
        realationShipStatus = {
          id: 'single',
          label: 'Solter@'
        }
        break
    }

    this.form = {
      name: this.getUser.first_name,
      lastName: this.getUser.last_name,
      gender: this.getUser.gender,
      career: this.getUser.major,
      semester: this.getUser.semester,
      linkedin: this.getUser.linkedin_url,
      facebook: this.getUser.facebook_url,
      instagram: this.getUser.instagram_url,
      google: this.getUser.google_url,
      realationShipStatus
    }
  }

  fileImage(file: any) {
    const reader = new FileReader()
    const self = this
    reader.addEventListener('load', function () {
      self.photoPerfil = reader.result as any
      self.$store.commit('PHOTO_USER', self.photoPerfil)
    }, false)

    if (file[0]) {
      reader.readAsDataURL(file[0])
    }
  }

  _birth() {
    let currentDate = new Date()
    this.birth.listDay = []
    this.birth.day = currentDate.getDate() as any
    for (let i = 0; i < 31; i++) {
      if ((i + 1) < 10) {
        this.birth.listDay.push(`0${i + 1}`)
      } else {
        this.birth.listDay.push(`${i + 1}`)
      }
    }
    this.birth.listMonth = []
    this.birth.month = (currentDate.getMonth() + 1) as any
    for (let i = 0; i < 12; i++) {
      if ((i + 1) < 10) {
        this.birth.listMonth.push(`0${i + 1}`)
      } else {
        this.birth.listMonth.push(`${i + 1}`)
      }
    }
    this.birth.listYear = []
    this.birth.year = (currentDate.getFullYear() - 20) as any
    let aux = currentDate.getFullYear()
    for (let i = 0; i < 120; i++) {
      aux = aux - 1
      this.birth.listYear.push(`${aux}`)
    }
  }

  async mounted () {
    await this.action_getUser()
    this._birth()
    this.fillForm()
  }
}
